import { Box } from '@interstate/components/Box';
import EntityErrorBadge from '../common/EntityErrorBadge';
import type { ReactNode } from 'react';
import type { EntityKey } from '@makemydeal/dr-dash-store/selectors/dealScreenErrorSelectors';

interface ActionWithErrorBadgeProps {
    entityName: EntityKey;
    children: ReactNode;
    xOffset?: string;
    yOffset?: string;
    /** Overrides the entity-wide count, for entities that hold errors for several rows. */
    hasError?: boolean;
}

export default function ActionWithErrorBadge({ entityName, children, xOffset, yOffset, hasError }: ActionWithErrorBadgeProps) {
    return (
        <Box display="inline-flex" position="relative">
            {children}
            <EntityErrorBadge
                entityName={entityName}
                showErrorCount={false}
                xOffset={xOffset}
                yOffset={yOffset}
                hasError={hasError}
            />
        </Box>
    );
}
